import Divider, { DividerProps } from '@mui/material/Divider';
import Tab, { TabProps } from '@mui/material/Tab';
import Tabs, { TabsProps } from '@mui/material/Tabs';
import React from 'react';

interface TabItem<T> {
  label?: React.ReactNode;
  value?: T;
}

interface TabsWrapperProps<T> extends TabsProps {
  value?: T;
  divider?: boolean;
  TabProps?: TabProps;
  DividerProps?: DividerProps;
  tabs: TabItem<T>[];
  onChange?: (event: React.SyntheticEvent, value: T) => void;
}

const TabsWrapper = <T,>({
  value,
  tabs,
  divider,
  TabProps,
  DividerProps,
  onChange,
  ...rest
}: TabsWrapperProps<T>) => {
  return (
    <>
      <Tabs
        value={value}
        onChange={onChange}
        sx={{ '& .MuiTabs-indicator': { height: '4px' } }}
        {...rest}
      >
        {tabs.map((tab, index) => (
          <Tab
            disableRipple
            {...TabProps}
            sx={{ textTransform: 'capitalize', ...TabProps?.sx }}
            key={index}
            label={tab.label}
            value={tab.value}
          />
        ))}
      </Tabs>
      {divider && <Divider {...DividerProps} sx={{ mt: '-1px', ...DividerProps?.sx }} />}
    </>
  );
};

export default TabsWrapper;
